module.exports = __webpack_public_path__ + "static/img/risolto_logo.7d347f10.png";